import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Actions } from '../actions/analytics.action';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsEventService {
  private analyticsEventSource = new BehaviorSubject<Actions | null>(null);
  analyticsEvent$ = this.analyticsEventSource.asObservable();

  constructor() { }

  reportAnalyticsEvent(action: Actions) {
    this.analyticsEventSource.next(action);
  }
}
